module.exports = __webpack_public_path__ + "static/media/Running.5c9b88d5.svg";